import { ListItemButton, ListItemIcon, ListItemText, ListItem } from "@mui/material";
import { ReactNode } from "react";
import {Link} from "react-router-dom";

interface Props {
  icon: ReactNode;
  text: string;
  to: string;
  onClick?: () => void;
}

export default function SidebarItem({ icon, text, to, onClick }: Props) {

  return (
    <ListItem component="nav">
    <ListItemButton
      component={Link}
      to={to}
      onClick={onClick}
      sx={{
        textDecoration: "none",
        "&:hover": {
          color: "#58342c",
          backgroundColor: "#EBD8C3"
        },
        borderRadius: 2,
      }}
    >
      <ListItemIcon sx={{
        textDecoration: "none",
        "&:hover": {
          color: "#58342c",
          backgroundColor: "#EBD8C3"
        }}}>{icon}</ListItemIcon>
      <ListItemText primary={text} />
    </ListItemButton>
    </ListItem>
  );
}
